import {useRef, useState, useEffect, useCallback} from 'react';

export const useScroll = (ref, initialSize=10, enable=false, searchTerm, expanded, groupBy, sourceToSearch, currentSoundInList, stretch) => {
    let [size, setSize] = useState(initialSize);
    let scrollPosition = useRef(0);
    
    useEffect(() => {
        if (ref.current) {
            ref.current.scrollTo(0, 0);
        }
        setSize(initialSize);
    }, [expanded, searchTerm, setSize, groupBy, initialSize]);

    useEffect(() => {
        if (currentSoundInList + 5 > size) {
            setSize(currentSoundInList + 20);
        }
    }, [currentSoundInList, size]);

    useEffect(() => {
        if (!enable || !ref.current ) {
            return;
        } 
        ref.current.addEventListener("scroll", onScroll);
        return () => ref.current && ref.current.removeEventListener("scroll", onScroll);
    }, [setSize, size, enable, ref.current, ref. initialSize]);

    const onScroll = useCallback((e) => {
        let el = ref.current;
        if (!el) {
            return;
        }
        scrollPosition.current = el.scrollTop;
        let bottom = el.scrollTop + el.offsetHeight;
        let height = el.scrollHeight;

        if (bottom >= height) { 
            setSize(size + initialSize);
        }
    }, [setSize, size, ref, initialSize]);

    return {size, scrollPosition};
};
 
